export default __webpack_public_path__ + "static/media/step2.8f250a7b.svg";